import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { MTable, MCard } from "components/Shared";
import { getInspectorDailySummary } from "requests/inspectorTimeCard/index.ts";

const daysOfTheWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const Summary = ({ employeeName, inspectorNumber, payPeriodId }) => {
  const mounted = useRef(true);
  const [inspectorSummary, setInspectorSummary] = useState();

  useEffect(() => () => mounted.current = false, []);

  useEffect(() => {
    setInspectorSummary(null);
    getInspectorDailySummary(inspectorNumber, payPeriodId, mapAndSetInspectorSummary, mounted);
  }, [inspectorNumber, payPeriodId]);

  const mapAndSetInspectorSummary = data => {
    const reduceToDays = (obj, total) => obj.timeByDayList.reduce((acc, d) => {
      acc[daysOfTheWeek[d.dayOfWeek]] = d.hours;
      return acc;
    }, { total: total === undefined ? "" : total });

    setInspectorSummary([
      { type: "Production Hours", ...reduceToDays(data.productionDailyHours, data.productionHoursTotal) },
      { type: "Non Production Hours", ...reduceToDays(data.nonProductionDailyHours, data.nonProductionHoursTotal) },
      { type: "Total Hours", ...reduceToDays(data.dailyHoursTotal) },
      { type: "Calendar Hours", ...reduceToDays(data.calendarDailyHours, data.calendarHoursTotal) },
    ]);
  };

  return (
    <MCard title="Summary">
      <MTable
        className="qa-table-employee-timelogs"
        columnDefinitions={[
          { name: employeeName, dataSource: "type", className: "qa-row", style: { width: "160px" } },
          ...daysOfTheWeek.map(day => ({ name: day, dataSource: day })),
          { name: "Total", dataSource: "total" },
        ]}
        data={inspectorSummary}
        emptyButtonText={"Loading Summary Data"}
      />
    </MCard>
  );
};

Summary.propTypes = {
  employeeName: PropTypes.string,
  inspectorNumber: PropTypes.number.isRequired,
  payPeriodId: PropTypes.number.isRequired,
};

export default Summary;